<template>
  <div class="accordian-display">
    <div :class="headerClass" @click="expandDetails = !expandDetails" class="interactive-cursor">
      <i :class="icon"></i> {{ title }}
      <i v-if="draggable" class="fa fa-fw fa-bars float-right mt-1 ml-2"></i>
      <span
        class="interactive-cursor fa fa-lg float-right mt-1"
        :class="expandDetails ? 'fa-chevron-up' : 'fa-chevron-down'" />
    </div>
    <div v-if="expandDetails" class="card-body p-1">
      <table class="table table-bordered table-striped table-hover table-sm mb-0">
        <thead class="thead-light">
          <slot name="header"></slot>
        </thead>
        <tbody>
          <slot></slot>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordianDisplay',
  props: {
    title: {
      type: String
    },
    icon: {
      type: String,
      default () {
        return ''
      }
    },
    headerClass: {
      type: String,
      default () {
        return 'card-header'
      }
    },
    defaultOpen: {
      type: Boolean,
      default () {
        return false
      }
    },
    draggable: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      expandDetails: false
    }
  },
  mounted () {
    if (this.defaultOpen) {
      this.expandDetails = true
    }
  },
  methods: {
    close () {
      this.expandDetails = false
    },
    open () {
      this.expandDetails = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AccordianDisplay.vue